import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pages/welcome/product-cover.jpg")